<section class="footer-section">
  <div class="wrapper">
    <div class="bottom-appbar">
      <div class="tabs">
        <div class="tab tab--left d-flex">
          <div class="menus">
            <div class="menu" [routerLink]="['/dashboard']" (click)="homeMenu()">
              <img [src]="isHomeActive ? home.imgActive : home.imgInActive" alt="Home"/>
              <p [ngClass]="{
                    'footer-label-active': isHomeActive,
                    'footer-label-inactive': !isHomeActive
                  }">
                {{ home.text }}
              </p>
            </div>
            <div class="menu" (click)="giftMenu()">
              <div *ngIf="router.url != '/giftcards' || isGiftActive">
                <img src="assets/icon/gift_Inactive.svg" alt="gift" />
              </div>
              <div *ngIf="router.url == '/giftcards' && !isGiftActive">
                <img src="assets/icon/Gift_Active.svg" alt="gift" />
              </div>
              <p [ngClass]="{
                    'footer-label-active': isGiftActive,
                    'footer-label-inactive': !isGiftActive
                  }">
                {{ gift.text }}
              </p>
            </div>
          </div>
        </div>
        <div class="tab tab--fab order-tab">
          <div class="top">
            <div class="fab" [routerLink]="['/ordering']">
              <img src="https://tsb-sit.reciproci.com/assets/icon/Group%20710.svg" alt="">
            </div>
          </div>
          <p [ngClass]="{
          'footer-label-active': isGiftActive,
          'footer-label-inactive': !isGiftActive
        }">
            {{ order.text }}
          </p>
        </div>
        <div class="tab tab--right d-flex">
          <div class="menus">
            <div class="menu" (click)="payMenu()">
              <div *ngIf="router.url != '/pay' || isPayActive">
                <img src="assets/icon/pay-filled.svg" alt="pay" />
              </div>
              <div *ngIf="router.url == '/pay' && !isPayActive">
                <img src="assets/icon/pay_Active.svg" alt="pay" />
              </div>
              <p [ngClass]="{
                  'footer-label-active': isPayActive,
                  'footer-label-inactive': !isPayActive
                }">
                {{ pay.text }}
              </p>
            </div>
            <div class="menu" (click)="closeBottomSheet()">
              <div *ngIf="router.url != '/search' || isSearchActive">
                <img src="assets/icon/Mask.svg" alt="search" />
              </div>
              <div *ngIf="router.url == '/search' && !isSearchActive">
                <img src="assets/icon/Serach_Active.svg" alt="search" />
              </div>
              <p [ngClass]="{
                  'footer-label-active': isSearchActive,
                  'footer-label-inactive': !isSearchActive
                }">
                {{ search.text }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
